// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PsNd","colBig":"styles_colBig__JBW5U","colSmall":"styles_colSmall__3LYgu"};